import { memo } from '@fantastic-utils/memo';
import validateColor from "validate-color";

export const isColor = memo((strColor = null) => {
    if (!strColor) return false;
    return validateColor(strColor);    
});